import * as ActionType from 'utils/ActionType';

const type = {
  SET_HOT_WORD_LIST: 'SET_HOT_WORD_LIST'
};

ActionType.handleType({ type, namespace: 'menu/' });

export default type;
